import { LayoutNodeActionType } from "@towersystems/roam-common/lib/generated-types";
import { forwardRef } from "react";
import {
  CancelSaleQuickKey,
  CustomerAccountPaymentQuickKey,
  CustomerLoyaltyPointsQuickKey,
  CustomerQuickKey,
  DiscountSaleQuickKey,
  ParkSaleQuickKey,
  SaleNoteQuickKey,
  SalesHistoryQuickKey,
  SwitchSaleQuickKey,
} from "../..";
import { QuickKey } from "../../../QuickKey";
import { ActionItemRendererProps } from "./types";
import { useEnhancedEventDetectionContextProvider } from "../../../InteractiveQuickKey/components/InteractivityWrapper/components/EnhancedEventDetection/hooks";
import { ApplySaleTradePriceQuickKey } from "../../quick-keys/ApplySaleTradePriceQuickKey";

export const ActionItemRenderer = forwardRef<any, ActionItemRendererProps>(
  ({ item, quickKeyProps }, ref) => {
    const maybeContext = useEnhancedEventDetectionContextProvider();
    const commonProps = {
      ref,
      selected: maybeContext?.inLongPress || maybeContext?.active,
      ...quickKeyProps,
    };

    switch (item.config?.action) {
      case LayoutNodeActionType.SWITCH_SALE:
        return <SwitchSaleQuickKey {...commonProps} />;

      case LayoutNodeActionType.ADD_CUSTOMER:
        return <CustomerQuickKey {...commonProps} />;

      case LayoutNodeActionType.APPLY_CUSTOMER_LOYALTY_POINTS:
        return <CustomerLoyaltyPointsQuickKey {...commonProps} />;

      case LayoutNodeActionType.PARK_SALE:
        return <ParkSaleQuickKey {...commonProps} />;

      case LayoutNodeActionType.DISCOUNT_SALE:
        return <DiscountSaleQuickKey {...commonProps} />;

      case LayoutNodeActionType.CANCEL_SALE:
        return <CancelSaleQuickKey {...commonProps} />;

      case LayoutNodeActionType.ADD_NOTE_TO_SALE:
        return <SaleNoteQuickKey {...commonProps} />;

      case LayoutNodeActionType.SALES_HISTORY:
        return <SalesHistoryQuickKey {...commonProps} />;

      case LayoutNodeActionType.CUSTOMER_ACCOUNT_PAYMENT:
        return <CustomerAccountPaymentQuickKey {...commonProps} />;
      case LayoutNodeActionType.APPLY_SALE_TRADE_PRICE:
        return <ApplySaleTradePriceQuickKey {...commonProps} />;
      default:
        return (
          <QuickKey
            {...commonProps}
            label={`Missing renderer for action: ${item.config?.action}`}
          />
        );
    }
  }
);
